import React from 'react'

const AdminBookingsIndex = () => {
    return (
        <div>I am the booking index</div>
    )
}

export default AdminBookingsIndex
